<template>
  <div class="intro-wrapper" :class="{ loaded: isLoaded }">
    <p v-html="textContent"></p>
    <img :src="resolvedImageSrc" :alt="imageAlt" />
  </div>
</template>

<script>
export default {
  name: "IntroWrapper",
  props: {
    textContent: {
      type: String,
      required: true,
      default: "Who<br>We Are", // 改行を含む文字列
    },
    imageFileName: {
      type: String,
      default: "datsu.jpg",
    },
    imageAlt: {
      type: String,
      default: "魚の模様", // 画像の説明
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
  resolvedImageSrc() {
    try {
      // @ を src に変換
      const defaultImagePath = require(`@/assets/img/common/${this.imageFileName}`);
      return defaultImagePath;
    } catch (error) {
      console.error("画像の解決に失敗しました:", error);
      return "";
    }
  },
},
  mounted() {
    // ロード時にアニメーション適用
    setTimeout(() => {
      this.isLoaded = true;
    }, 500);
  },
};
</script>

<style scoped>
.intro-wrapper {
  position: relative;
  width: 100%;
  height: 700px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 180px;
  margin-top: 100px;
  background-color: hsla(178, 0%, 100%, 1);
  opacity: 0;
  transform: translateY(-3px);
}

.intro-wrapper.loaded {
  transition: opacity 0.7s ease-in-out, transform 0.6s ease-in-out;
  opacity: 1;
  transform: translateY(0px);
}

.intro-wrapper img {
  width: 400px;
  height: 500px;
  object-fit: cover;
  z-index: 1;
  box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
}

.intro-wrapper p {
  width: fit-content;
  height: auto;
  font-size: 30px;
  font-family: sans-serif;
  font-weight: 600;
  color: #003633;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {
  .intro-wrapper {
    height: 450px;
    gap: 60px;
    margin-top: 150px;
  }

  .intro-wrapper img {
    width: 280px;
    height: 400px;
  }

  .intro-wrapper p {
    font-size: 25px;
    font-weight: 600;
  }
}

@media screen and (max-width: 570px) {
  .intro-wrapper {
    height: 550px;
    flex-direction: column;
    gap: 80px;
    margin-top: 100px;
  }

  .intro-wrapper img {
    width: 240px;
    height: 300px;
  }

  .intro-wrapper p {
    font-size: 12px;
    font-weight: 300;
    text-align: center;
    color: var(#525252);
  }
}
</style>